import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/HackathonClaimSubmission';
// FOR ONE GRAPHQL QUERY
export const SUBMIT_CLAIM = defineAsyncActionTypes(`${prefix}/SUBMIT_CLAIM`);
